import { render, staticRenderFns } from "./tag-form.vue?vue&type=template&id=63ad1206&"
import script from "./tag-form.vue?vue&type=script&lang=js&"
export * from "./tag-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports